import { cn } from '@crossnokaye/ux-common';

interface TopNavigationContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

export const TopNavigationContainer = ({
  children,
  className,
  ...props
}: TopNavigationContainerProps) => {
  return (
    <div className={cn('bg-background', className)} {...props}>
      {children}
    </div>
  );
};
